import styled from "styled-components";

export const Hr = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(8, 10, 37, 0.08);
`;